<template>
  <div></div>
</template>

<script>
import { bindWechat } from '../../api/userBind'

export default {
  name: 'WxLoginSuccess',
  created () {
    const code = this.$route.query.code
    const state = this.$route.query.state
    bindWechat({
      code, state
    })
      .then(data => {
        // 存在冲突的账户，跳转至主账户选择页面
        if (data.existsAccount) {
          this.$router.push('/usr/bind/select-account')
          return
        }
        // 跳转至绑定成功页面
        this.$router.push('/usr/bind/success?bt=微信')
      })
      .catch(e => {
        this.$router.push(`/500?code=${e.code}&error=${e.message}`)
      })
  }
}
</script>
